module.exports = __webpack_public_path__ + "img/IRES_GmbH_sRGB.68125a2b.png";